import { InjectionToken } from '@angular/core';

export const APP_CONFIG = new InjectionToken('app.config');

export const AppConfig = {
  routes: {
    home: 'home',
    callback: 'callback',
    error401: 'unauthorized',
    error403: 'forbidden',
    error404: 'not-found',
    error500: 'internal-error',
    invalidInvite: 'invalid-invite',
    styleGuide: 'style-guide',
    user: 'user',
    users: 'user/list',
    account: 'user/me',
    applications: 'applications',
    dashboard: 'dashboard',
    vacancy: 'vacancy',
    vacancies: 'vacancies',
    company: 'company-profiles',
    claimManagement: 'claim-management',
    incompleteOnboarding: 'incomplete-onboarding',
    onboarding: 'onboarding',
    step2: '2',
    step3: '3',
    logout: 'logout',
    login: 'login',
    passwordlessLogin: 'passwordless-login',
    passwordlessLoginLinkSent: 'link-sent',
    passwordlessLoginLinkExpired: 'link-expired',
    resetPassword: 'reset-password',
    summary: 'summary',
    checkout: 'checkout',
    productsOptions: 'product-options',
    productsHistory: 'product-history',
    promotion: 'promotion',
    credits: 'credits',
    creditManagement: 'credit-management',
    creditId: ':creditId',
    extend: 'extend',
    purchaseHistory: 'purchase-history',
    purchaseHistoryTab: ':purchaseHistoryTab',
    purchaseCredits: 'purchase-credits',
    list: 'list',
    id: ':id',
    companyProfileId: ':id/edit',
    vacancyGroup: 'vacancy-group',
    vacancyGroupCreate: 'vacancy-group/create',
    vacancyGroupEdit: 'vacancy-group/:vacancyGroupId',
    success: 'success',
    orderComplete: 'order-complete',
    redemptionError: 'redemption-error',
    me: 'me',
    new: 'new',
    about: 'about',
    edit: 'edit',
    duplicate: 'duplicate',
    preview: 'preview',
    invoices: 'invoices',
    invoiceDetails: 'details/:id',
    productOffering: 'product-offering',
    unsubscribe: 'unsubscribe',
    verifyIdentity: 'verify-identity',
    claimCompany: 'claim-company',
    createCompany: 'create-company',
    create: 'create',
    publish: 'publish',
    textEditor: 'text-editor',
    orderSummary: 'order-summary',
    purchaseCreditsCommparison: 'comparison',
    selectAccountMembership: 'select-workspace',
    ui: 'ui',
    vbpShowroom: 'vbp-showroom',
    accountSettings: 'settings',
    workspace: 'workspace',
    userManagement: 'user-management',
    createInvite: 'create-invite',
    redeemInvite: 'redeem-invite',
    legalEntity: 'company',
    payPerInvite: 'invite-candidates',
    cookieSettings: 'cookie-settings',
  },
  sentry: {
    dsn: 'https://4ce8b65677ff4839814b92ef12425be5@sentry.io/1445521',
  },
  vacancyTypeaheadMaxLength: 100,
  creditRedemptionsGap: 2,
  pagination: {
    pageSize: 20,
  },
  defaultProfilePicture: '/assets/images/uploadplaceholder.png',
  pictureSize: 'x200x200',
  fakeId: '87623guidvsjghr48798few',
  uploadPlaceHolder: '/assets/images/upload.png',
  hashingSecret: 'HeyPascalCanYouReverseThisPassword',
  shopTaxon: 'JS24',
  minimumPictureSize: 320,
  onboardingCfg: {
    startingStep: 1,
    numberOfSteps: 5,
  },
};

// apps served on ONE's origin under their own base href, outside ONE's router
export const SameOriginAppPaths = ['/analytics/'];

export const LocalStorageKeys = {
  redirectUri: 'redirectUri',
  workspaceSelectionRedirectUri: 'workspaceSelectionRedirectUri',
  onboardingUser: 'onboardingUser',
  logoGuidance: 'logoGuidance',
  atsPayPerInviteBannerDismissed: 'atsPayPerInviteBannerDismissed',
};
